module.exports = __webpack_public_path__ + "files/752d836d19ed3ce4d72d1753feb12404.png";